import { cadCurrencyFormat } from "./constants";

/**
 * @param {number | null | undefined} avgUnit
 * @param {string | undefined} unit e.g. kg, lb
 * @returns {string | null} Display value for primary chip, or null when no price
 */
export function formatAggregateCardPrimaryMetricValue(avgUnit, unit) {
  if (avgUnit == null || Number.isNaN(Number(avgUnit))) {
    return null;
  }
  const formattedPrice = cadCurrencyFormat.format(avgUnit);
  const unitLabel = typeof unit === "string" ? unit.trim() : "";
  if (!unitLabel) return formattedPrice;
  return `${formattedPrice} / ${unitLabel}`;
}

/** @param {object} row Aggregate table row */
export function buildAggregateCardPrimaryMetric(row) {
  const value = formatAggregateCardPrimaryMetricValue(row?.avgUnit, row?.unit);
  if (!value) return null;
  return { label: "Avg price", value };
}

/**
 * @param {string | null | undefined} retailer
 * @param {string | null | undefined} province
 * @returns {string | null}
 */
export function formatImageCardRetailerProvinceDescription(retailer, province) {
  const retailerLabel = retailer != null ? String(retailer).trim() : "";
  const provinceLabel = province != null ? String(province).trim() : "";
  if (retailerLabel && provinceLabel) return `${retailerLabel} - ${provinceLabel}`;
  return retailerLabel || provinceLabel || null;
}

/**
 * @param {object} row Aggregate table row
 * @returns {{ label?: string, value: string }[]}
 */
export function buildAggregateCardMetaChips(row) {
  const chips = [];
  if (row?.month) chips.push({ label: "Month", value: String(row.month) });
  const observationCount = Number(row?.n) || 0;
  if (observationCount > 0) {
    chips.push({
      label: "Count",
      value: observationCount === 1 ? "1 observation" : `${observationCount} observations`,
    });
  }
  return chips;
}

/**
 * @param {object | null | undefined} displayItem Flyer gallery display item
 */
export function buildFlyerGalleryCardPrimaryMetric(displayItem) {
  const saleAmount = displayItem?.saleAmount;
  if (!saleAmount || saleAmount === "—") return null;
  return { label: "Sale", value: String(saleAmount) };
}

/**
 * @param {object | null | undefined} displayItem
 */
export function buildFlyerGalleryCardMetaChips(displayItem) {
  const chips = [];
  if (displayItem?.recordAt && displayItem.recordAt !== "—") {
    chips.push({ label: "Date", value: String(displayItem.recordAt) });
  }
  if (displayItem?.saleType && displayItem.saleType !== "—") {
    chips.push({ label: "Type", value: String(displayItem.saleType) });
  }
  return chips;
}

/**
 * @param {{ label?: string, value?: string } | null | undefined} primaryMetric
 * @param {{ label?: string, value?: string }[]} metaChips
 */
export function formatInsightsImageCardAriaLabel(title, description, primaryMetric, metaChips) {
  return [
    title,
    description,
    primaryMetric?.value,
    ...(metaChips || []).map((chip) => chip.value).filter(Boolean),
  ]
    .filter(Boolean)
    .join(", ");
}
